type Props = {
  width?: string | number,
  className?: string,
}

const BrowserBarMock = ({ width = '100%', className = '' }: Props) =>
  <svg width={ width } viewBox="0 0 1280 37" fill="none" className={`rounded-t-md ${className}`}>
    <g clipPath="url(#clip0_2_40)">
    <path d="M0 5C0 2.23858 2.23858 0 5 0H1275C1277.76 0 1280 2.23858 1280 5V37H0V5Z" fill="white"/>
    <g filter="url(#filter0_dd_2_40)">
    <rect width="1280" height="37" fill="url(#paint0_linear_2_40)"/>
    </g>
    <g filter="url(#filter1_ii_2_40)">
    <rect x="1255" y="12" width="25" height="25" fill="#2B2B2C"/>
    </g>
    <path d="M1268 19H1267V24H1262V25H1267V30H1268V25H1273V24H1268V19Z" fill="#949494"/>
    <g filter="url(#filter2_i_2_40)">
    <rect x="380" y="8" width="520" height="22" rx="4" fill="url(#paint1_linear_2_40)"/>
    </g>
    <path d="M887.5 17.5646L892 14.75L887.5 11.9354V14.0224C884.697 14.275 882.5 16.631 882.5 19.5C882.5 22.5375 884.962 25 888 25C891.038 25 893.5 22.5375 893.5 19.5V19H892.5V19.5C892.5 21.9853 890.485 24 888 24C885.515 24 883.5 21.9853 883.5 19.5C883.5 17.1837 885.25 15.2762 887.5 15.0275V17.5646Z" fill="#E9E9E9"/>
    <g filter="url(#filter3_i_2_40)">
    <rect x="104" y="8" width="25" height="22" rx="4" fill="url(#paint2_linear_2_40)"/>
    </g>
    <path d="M113.934 24.1563L118.847 19.2429C118.879 19.211 118.904 19.1732 118.922 19.1315C118.939 19.0898 118.948 19.0451 118.948 19C118.948 18.9549 118.939 18.9102 118.922 18.8685C118.904 18.8268 118.879 18.789 118.847 18.7571L113.934 13.8438" stroke="#919292" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <g filter="url(#filter4_i_2_40)">
    <rect x="77.9999" y="8" width="25" height="22" rx="4" fill="url(#paint3_linear_2_40)"/>
    </g>
    <path d="M92.9478 24.1563L88.0345 19.2429C88.0026 19.211 87.9772 19.1732 87.96 19.1315C87.9427 19.0898 87.9338 19.0451 87.9338 19C87.9338 18.9549 87.9427 18.9102 87.96 18.8685C87.9772 18.8268 88.0026 18.789 88.0345 18.7571L92.9478 13.8438" stroke="#FCFDFD" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <g filter="url(#filter5_i_2_40)">
    <path fillRule="evenodd" clipRule="evenodd" d="M19 25C22.3137 25 25 22.3137 25 19C25 15.6863 22.3137 13 19 13C15.6863 13 13 15.6863 13 19C13 22.3137 15.6863 25 19 25Z" fill="#ED6A5E"/>
    </g>
    <path d="M24.75 19C24.75 22.1756 22.1756 24.75 19 24.75C15.8244 24.75 13.25 22.1756 13.25 19C13.25 15.8244 15.8244 13.25 19 13.25C22.1756 13.25 24.75 15.8244 24.75 19Z" stroke="#CE5347" strokeWidth="0.5"/>
    <g filter="url(#filter6_i_2_40)">
    <path fillRule="evenodd" clipRule="evenodd" d="M39 25C42.3137 25 45 22.3137 45 19C45 15.6863 42.3137 13 39 13C35.6863 13 33 15.6863 33 19C33 22.3137 35.6863 25 39 25Z" fill="#F6BE4F"/>
    </g>
    <path d="M44.75 19C44.75 22.1756 42.1756 24.75 39 24.75C35.8244 24.75 33.25 22.1756 33.25 19C33.25 15.8244 35.8244 13.25 39 13.25C42.1756 13.25 44.75 15.8244 44.75 19Z" stroke="#D6A243" strokeWidth="0.5"/>
    <g filter="url(#filter7_i_2_40)">
    <path fillRule="evenodd" clipRule="evenodd" d="M59 25C62.3137 25 65 22.3137 65 19C65 15.6863 62.3137 13 59 13C55.6863 13 53 15.6863 53 19C53 22.3137 55.6863 25 59 25Z" fill="#62C554"/>
    </g>
    <path d="M64.75 19C64.75 22.1756 62.1756 24.75 59 24.75C55.8244 24.75 53.25 22.1756 53.25 19C53.25 15.8244 55.8244 13.25 59 13.25C62.1756 13.25 64.75 15.8244 64.75 19Z" stroke="#58A942" strokeWidth="0.5"/>
    </g>
    <path d="M1280 37V37.5H1280.5V37H1280ZM0 37H-0.5V37.5H0V37ZM5 0.5H1275V-0.5H5V0.5ZM1279.5 5V37H1280.5V5H1279.5ZM1280 36.5H0V37.5H1280V36.5ZM0.5 37V5H-0.5V37H0.5ZM1275 0.5C1277.49 0.5 1279.5 2.51472 1279.5 5H1280.5C1280.5 1.96243 1278.04 -0.5 1275 -0.5V0.5ZM5 -0.5C1.96243 -0.5 -0.5 1.96243 -0.5 5H0.5C0.5 2.51472 2.51472 0.5 5 0.5V-0.5Z" fill="#060606"/>
    <defs>
    <filter id="filter0_dd_2_40" x="0" y="0" width="1280" height="38" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2_40"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="0.5"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.152941 0 0 0 0 0.156863 0 0 0 0 0.156863 0 0 0 1 0"/>
    <feBlend mode="normal" in2="effect1_dropShadow_2_40" result="effect2_dropShadow_2_40"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_2_40" result="shape"/>
    </filter>
    <filter id="filter1_ii_2_40" x="1255" y="12" width="25" height="25" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="0.5"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.380392 0 0 0 1 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2_40"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dx="1"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.380392 0 0 0 1 0"/>
    <feBlend mode="normal" in2="effect1_innerShadow_2_40" result="effect2_innerShadow_2_40"/>
    </filter>
    <filter id="filter2_i_2_40" x="380" y="8" width="520" height="22" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="0.5"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2_40"/>
    </filter>
    <filter id="filter3_i_2_40" x="104" y="8" width="25" height="22" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="0.5"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2_40"/>
    </filter>
    <filter id="filter4_i_2_40" x="77.9999" y="8" width="25" height="22" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="0.5"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2_40"/>
    </filter>
    <filter id="filter5_i_2_40" x="13" y="13" width="12" height="12" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset/>
    <feGaussianBlur stdDeviation="3"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.92549 0 0 0 0 0.427451 0 0 0 0 0.384314 0 0 0 1 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2_40"/>
    </filter>
    <filter id="filter6_i_2_40" x="33" y="13" width="12" height="12" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset/>
    <feGaussianBlur stdDeviation="3"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 0 0.317647 0 0 0 1 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2_40"/>
    </filter>
    <filter id="filter7_i_2_40" x="53" y="13" width="12" height="12" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset/>
    <feGaussianBlur stdDeviation="3"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.407843 0 0 0 0 0.8 0 0 0 0 0.345098 0 0 0 1 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2_40"/>
    </filter>
    <linearGradient id="paint0_linear_2_40" x1="640" y1="0" x2="640" y2="37" gradientUnits="userSpaceOnUse">
    <stop stopColor="#424343"/>
    <stop offset="0.994048" stopColor="#363737"/>
    </linearGradient>
    <linearGradient id="paint1_linear_2_40" x1="640" y1="8" x2="640" y2="30" gradientUnits="userSpaceOnUse">
    <stop stopColor="#707071"/>
    <stop offset="1" stopColor="#6A6A6A"/>
    </linearGradient>
    <linearGradient id="paint2_linear_2_40" x1="116.5" y1="8" x2="116.5" y2="30" gradientUnits="userSpaceOnUse">
    <stop stopColor="#707071"/>
    <stop offset="1" stopColor="#6A6A6A"/>
    </linearGradient>
    <linearGradient id="paint3_linear_2_40" x1="90.4999" y1="8" x2="90.4999" y2="30" gradientUnits="userSpaceOnUse">
    <stop stopColor="#707071"/>
    <stop offset="1" stopColor="#6A6A6A"/>
    </linearGradient>
    <clipPath id="clip0_2_40">
    <path d="M0 5C0 2.23858 2.23858 0 5 0H1275C1277.76 0 1280 2.23858 1280 5V37H0V5Z" fill="white"/>
    </clipPath>
    </defs>
  </svg>


export default BrowserBarMock
